import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useDynamicModule } from '@grandvisionhq/utils';

const AdyenContext = /*#__PURE__*/ React.createContext({
    clientKey: '',
    environment: 'test',
    AdyenModule: {
        result: undefined,
        loading: true
    }
});
const useAdyen = ()=>React.useContext(AdyenContext)
;
const AdyenProvider = ({ children , settings  })=>{
    // The `@adyen/adyen-web` package uses a hard reference to the global `window` variable. This makes it
    // impossible to import the package in a normal manner. Hence the choice to use dynamic importing.
    const [result, loading] = useDynamicModule(swcHelpers.asyncToGenerator(function*() {
        if (typeof window !== 'undefined') {
            return yield import('@adyen/adyen-web').then((module)=>module.default
            );
        }
        return undefined;
    }), '@adyen/adyen-web', []);
    const [pspInfo, setPspInfo] = React.useState(settings === null || settings === void 0 ? void 0 : settings.pspInfo);
    const updatePspInfo = React.useCallback((updates)=>{
        setPspInfo((prev)=>{
            const isMerchantConfigUnchanged = (prev === null || prev === void 0 ? void 0 : prev.merchantId) === updates.merchantId && (prev === null || prev === void 0 ? void 0 : prev.merchantName) === updates.merchantName && (prev === null || prev === void 0 ? void 0 : prev.gatewayMerchantId) === updates.gatewayMerchantId;
            if (isMerchantConfigUnchanged) return prev;
            return swcHelpers.objectSpread({}, prev, updates);
        });
    }, []);
    const memoizedSettings = React.useMemo(()=>swcHelpers.objectSpread({}, settings, {
            pspInfo,
            updatePspInfo,
            AdyenModule: {
                result: result !== null && result !== void 0 ? result : undefined,
                loading
            }
        })
    , [
        settings,
        pspInfo,
        result,
        loading,
        updatePspInfo
    ]);
    return /*#__PURE__*/ React.createElement(AdyenContext.Provider, {
        value: memoizedSettings
    }, children);
};

export { AdyenProvider, useAdyen };
//# sourceMappingURL=context.js.map
